var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keys.length > 0)?_c('span',{class:['control-types', _vm.className]},_vm._l((_vm.keys),function(key,index){return _c('img',{key:index,attrs:{"src":require(`../assets/img/${key}.png`),"alt":""}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }